import { PlusOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { DESC, ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import React, { useEffect, useState } from 'react';
import { getPaginationState } from 'react-jhipster';
import { useLocation } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Input, Modal, Row, Tooltip } from 'antd';
import Title from 'antd/es/typography/Title';
import { setListFilterEvaluationLevel } from 'app/entities/filters/filters.reducer';
import ModalConfirmComponent from 'app/shared/component/modal/confirm';
import TableComponent from 'app/shared/component/table/table';
import * as _ from 'lodash';
import { deleteEntity, getEntities } from '../evaluation-level.reducer';
import EvaluationLevelUpdate from '../form/evaluation-level';
import { columns } from './config';
import { fetchCurrentStatusProcess } from './modal/category-evaluation.reducer';

const { Search } = Input;
type IApproveModal = {
  isOpen: boolean,
  onClose: () => void,
}

export const EvaluationLevel = ({ isOpen, onClose }: IApproveModal) => {
  const dispatch = useAppDispatch();
  const pageLocation = useLocation();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'lastModifiedDate', DESC), pageLocation.search),
  );

  const filtersObjective = useAppSelector(state => state.filters.objective);
  const filters = useAppSelector(state => state.filters.evaluationLevel);
  const evaluationLevelList = useAppSelector(state => state.evaluationLevel.entities);
  const isLoading = useAppSelector(state => state.evaluationLevel.loading);
  const isDeleting = useAppSelector(state => state.evaluationLevel.updating);
  const currentStatusProcess = useAppSelector(state => state.categoryEvaluation.entity);

  const [visibleConfirmDelete, setVisibleConfirmDelete] = useState(false);
  const [isOpenForm, setOpenForm] = useState(false);
  const [itemSelected, setItemSelected] = useState(null);

  // config columns, actions add plan period
  const newColumns = [
    ...columns,
    {
      title: 'Hành động',
      key: 'Action',
      fixed: 'right',
      width: 80,
      render: (item: any) => (
        Object.keys(currentStatusProcess).length <= 0 &&
        <div className="action">
          <span className="action-edit">
            <Tooltip title="Sửa">
              <FontAwesomeIcon onClick={() => {
                handleOpenForm(item);
              }} icon="pencil-alt" />
            </Tooltip>
          </span>
          <span className="action-delete">
            <Tooltip title="Xóa">
              <FontAwesomeIcon
                onClick={() => {
                  handleWarningDeleteItem(item);
                }}
                icon="trash"
              />
            </Tooltip>
          </span>
        </div>
      ),
    },
  ];

  // end config
  useEffect(() => {
    dispatch(setListFilterEvaluationLevel({ ...filtersObjective }))
  }, [filtersObjective]);

  useEffect(() => {
    if (filters?.accountableId) {
      getAllEntities();
      handleFetCurrentStatusProcess();
    }
  }, [filters]);

  const getAllEntities = () => {
    if (filters.accountableId) {
      dispatch(
        getEntities({ ownerId: filters.accountableId, planPeriodId: filters.planPeriodId }),
      );
    }
  };

  const handleChange = (pageNumber: number, size: number, sorter: any) => {
    setPaginationState({
      ...paginationState,
      order: DESC,
      sort: sorter.columnKey,
      activePage: pageNumber,
      itemsPerPage: size,
    });
  };

  const handleWarningDeleteItem = (item: any) => {
    setVisibleConfirmDelete(true);
    setItemSelected(item);
  };

  const handleConfirmDelete = () => {
    if (itemSelected) {
      dispatch(deleteEntity(itemSelected.id))
        .then(() => {
          getAllEntities();
        })
        .finally(() => {
          setVisibleConfirmDelete(false);
        });
    }
  };

  const handleFreeTextSearchQuery = query => {
    dispatch(setListFilterEvaluationLevel({ ...filters, searchText: query }))
  };

  const handleOpenForm = (item = undefined) => {
    setOpenForm(true);
    setItemSelected(item)
  };

  const handleCloseModalForm = (isReload = false) => {
    setOpenForm(false);
    setItemSelected(null);
    if (isReload) {
      getAllEntities();
    }
  };

  const handleCloseModal = () => {
    dispatch(setListFilterEvaluationLevel(null))
    onClose()
  }

  const handleFetCurrentStatusProcess = () => {
    dispatch(fetchCurrentStatusProcess({ ownerId: filters?.accountableId, year: filters?.year, planPeriodId: filters?.planPeriodId }));
  }


  return (
    <Modal open={isOpen} maskClosable={false} footer={null} onCancel={handleCloseModal} width={'80vw'} className='view'>
      <div className="d-flex gap-5">
        <Title level={3}>{`Thiết lập cấp đánh giá ${filters?.accountableName ? `- ${filters?.accountableName}` : ''}`}</Title>
      </div>
      <div className="table">
        <div className="header">
          <Col md={18}>
            <Row className='w-100'>
              <Col md={18}>
                <Search size="large" allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row className='w-100 justify-content-end'>
              {
                Object.keys(currentStatusProcess).length <= 0 &&
                (
                  <Button size="large" onClick={handleOpenForm} className="primary">
                    <PlusOutlined /> Thêm mới
                  </Button>
                )
              }
            </Row>
          </Col>
        </div>
        <TableComponent
          data={evaluationLevelList.map((x, index) => {
            return {
              key: index + 1,
              ...x,
            };
          })}
          scroll={false}
          noPagination={true}
          isFetching={isLoading}
          columns={newColumns}
          handlePageChange={(pageNumber: number, size: number, search: any, sorter: any) => {
            handleChange(pageNumber, size, sorter);
          }}
        />
      </div>
      {isOpenForm && <EvaluationLevelUpdate isOpen={isOpenForm} onClose={handleCloseModalForm} idItemSelected={itemSelected?.id} />}
      <ModalConfirmComponent
        visible={visibleConfirmDelete}
        onCancel={() => {
          setVisibleConfirmDelete(false);
        }}
        isLoading={isDeleting}
        onConfirm={handleConfirmDelete}
        title={`Bạn có muốn xóa thiết lập ${itemSelected?.name}`}
      />
    </Modal>
  );
};

export default EvaluationLevel;
